import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location);
};
const originalPush2 = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalPush2.call(this, location);
};
console.log("APP_MD", APP_MD);

switch (APP_MD) {
  case "omg":
    require("@/style_omg/loadimage.js");
    if (APP_MD == "omg") {
      require("@/style_omg/css/index.css");
    }
    break;
  case "dd":
    require("@/style_dd/loadimage.js");
    if (APP_MD == "dd") {
      require("@/style_dd/css/index.css");
    }
    break;
  case "hs":
    require("@/style_hs/loadimage.js");
    if (APP_MD == "hs") {
      require("@/style_hs/css/index.css");
    }
    break;
  default:
    require("@/style_base/loadimage.js");
    break;
}

export default new Router({
  routes: [
    {
      path: "/login/:tenantNo",
      name: "login",
      component: () => import("@/components/login/index"),
      meta: { title: "老师登录", isNotShowBar: true }
    },
    {
      path: "/login",
      name: "login2",
      component: () => import("@/components/login/index"),
      meta: { title: "老师登录", isNotShowBar: true }
    },
    {
      path: "/loginSimple/:tenantNo",
      name: "loginSimple",
      component: () => import("@/components/LoginSimple/index"),
      meta: { title: "老师登录", isNotShowBar: true }
    },
    {
      path: "/loginPhone",
      name: "loginPhone",
      component: () => import("@/components/etmsAndroid/login"),
      meta: { title: "老师登录", isNotShowBar: true }
    },
    {
      path: "/registerPhone",
      name: "registerPhone",
      component: () => import("@/components/etmsAndroid/register"),
      meta: { title: "注册账号" }
    },
    {
      path: "/loginUnion/:unionNo",
      name: "loginUnion",
      component: () => import("@/components/loginUnion"),
      meta: { title: "老师登录", isNotShowBar: true }
    },
    {
      path: "/loginTool/:tenantNo",
      name: "loginTool",
      component: () => import("@/components/loginTool/index"),
      meta: { title: "登录中...", isNotShowBar: true }
    },
    {
      path: "/homePage",
      name: "homePage",
      // component: () => import("@/components/homePage/index"),//旧
      component: () => import("@/components/homePage/homePage"), //新
      meta: { title: "首页", isNotShowBar: true, index: 10 }
    },
    {
      path: "/timetable",
      name: "timetable",
      component: () => import("@/components/timetable/timetable"),
      meta: { title: "课表", keepAlive: true, index: 30 }
    },
    {
      path: "/timetable/:id",
      name: "timetableID", //路由添显示重复故改成timetableID
      component: () => import("@/components/timetable/timetable"),
      meta: { title: "课表", keepAlive: true }
    },
    {
      path: "/timetableDetail/:id",
      name: "timetableDetail",
      component: () => import("@/components/timetable/timetableDetail"),
      meta: { title: "课表详情" }
    },
    {
      path: "/rollCall",
      name: "rollCall",
      component: () => import("@/components/rollCall/rollCallRe"),
      meta: { title: "点名" }
    },
    {
      path: "/rollCallOld",
      name: "rollCallOld",
      component: () => import("@/components/rollCall/rollCall"),
      meta: { title: "点名" }
    },
    {
      path: "/rollCallTime",
      name: "rollCallTime",
      component: () => import("@/components/rollCall/rollCallTime"),
      meta: { title: "点名", keepAlive: true, index: 30 }
    },
    {
      path: "/classList",
      name: "classList",
      component: () => import("@/components/rollCall/classList"),
      meta: { title: "选择班级" }
    },
    {
      path: "/addStudent",
      name: "addStudent",
      component: () => import("@/components/rollCall/addStudent"),
      meta: { title: "选择学员" }
    },
    {
      path: "/rollCallRecord",
      name: "rollCallRecord",
      component: () => import("@/components/rollCallRecord/rollCallRecord"),
      meta: { title: "点名记录", keepAlive: true, index: 30 }
    },
    {
      path: "/rollCallRecordDetails/:id",
      name: "rollCallRecordDetails",
      component: () =>
        import("@/components/rollCallRecord/rollCallRecordDetails2"),
      meta: { title: "点名记录详情" }
    },
    {
      path: "/homeWorkList",
      name: "homeWorkList",
      component: () => import("@/components/homeWork/homeWorkList"),
      meta: { title: "课后作业", keepAlive: true, index: 30 }
    },
    {
      path: "/homeWorkDetails/:id",
      name: "homeWorkDetails",
      component: () => import("@/components/homeWork/homeWorkDetails"),
      meta: { title: "作业详情" }
    },
    {
      path: "/addHomeWork",
      name: "addHomeWork",
      component: () => import("@/components/homeWork/addHomeWork"),
      meta: { title: "布置单次作业" }
    },
    {
      path: "/addHomeWork1",
      name: "addHomeWork1",
      component: () => import("@/components/homeWork/addHomeWork1"),
      meta: { title: "布置连续作业" }
    },
    {
      path: "/checkClassAndStudent",
      name: "checkClassAndStudent",
      component: () => import("@/components/homeWork/checkClassAndStudent"),
      meta: { title: "选择班级学员" }
    },
    {
      path: "/studentList",
      name: "studentList",
      component: () => import("@/components/StudentFiles/studentList/index"),
      meta: { title: "学员档案", keepAlive: true, index: 30 }
    },
    {
      path: "/addPotential",
      name: "addPotential",
      component: () => import("@/components/StudentFiles/addPotential/index")
    },
    {
      path: "/BasicInformation",
      name: "BasicInformation",
      component: () =>
        import("@/components/StudentFiles/studentDetails/cpn/BasicInformation")
    },
    {
      path: "/studentDetails/:id",
      name: "studentDetails",
      component: () => import("@/components/StudentFiles/studentDetails/index"),
      meta: { title: "学员详情" }
    },
    {
      path: "/classRecord/:id",
      name: "classRecord",
      component: () => import("@/components/StudentFiles/classRecord/index"),
      meta: { title: "上课记录" }
    },
    {
      path: "/classRecordDetail/:id",
      name: "classRecordDetail",
      component: () =>
        import("@/components/StudentFiles/classRecordDetail/index"),
      meta: { title: "上课记录" }
    },
    {
      path: "/coupon/:id",
      name: "coupon",
      component: () => import("@/components/StudentFiles/coupon/index"),
      meta: { title: "优惠券" }
    },
    {
      path: "/curriculum/:id",
      name: "curriculum",
      component: () => import("@/components/StudentFiles/curriculum/index"),
      meta: { title: "报读课程" }
    },
    {
      path: "/giftRecord/:id",
      name: "giftRecord",
      component: () => import("@/components/StudentFiles/giftRecord/index"),
      meta: { title: "礼品兑换" }
    },
    {
      path: "/IntegralRecord/:id",
      name: "IntegralRecord",
      component: () => import("@/components/StudentFiles/IntegralRecord/index"),
      meta: { title: "积分记录" }
    },
    {
      path: "/orderPayhistory",
      name: "orderPayhistory",
      component: () => import("@/components/orderPayhistory/index"),
      meta: { keepAlive: true, index: 30 }
    },
    {
      path: "/orderPayhistory2",
      name: "orderPayhistory2",
      component: () => import("@/components/orderPayhistory2/index"),
      meta: { index: 30 }
    },
    {
      path: "/orderDetail/:id",
      name: "orderDetail",
      component: () => import("@/components/orderDetail/index"),
      meta: { title: "消费记录详情" }
    },
    {
      path: "/orderReturnDetail/:id",
      name: "orderReturnDetail",
      component: () => import("@/components/orderReturnDetail/index"),
      meta: { title: "消费记录详情" }
    },
    {
      path: "/transferCoursesDetail/:id",
      name: "transferCoursesDetail",
      component: () => import("@/components/transferCoursesDetail/index"),
      meta: { title: "消费记录详情" }
    },
    {
      path: "/rechargeDetail/:id",
      name: "rechargeDetail",
      component: () =>
        import(
          "@/components/orderPayhistory/components/Detail/RechargeDetail.vue"
        ),
      meta: { title: "消费记录详情" }
    },
    {
      path: "/refundDetail/:id",
      name: "refundDetail",
      component: () =>
        import(
          "@/components/orderPayhistory/components/Detail/RefundDetail.vue"
        ),
      meta: { title: "消费记录详情" }
    },
    {
      path: "/rechargeCardDetail/:id",
      name: "rechargeCardDetail",
      component: () =>
        import(
          "@/components/orderPayhistory/components/Detail/RechargeCardDetail.vue"
        ),
      meta: { title: "消费记录详情" }
    },
    {
      path: "/recharge",
      name: "recharge",
      component: () => import("@/components/Recharge/index"),
      meta: { title: "充值管理" }
    },
    {
      path: "/followList/:id",
      name: "followList",
      component: () => import("@/components/StudentFiles/followList/index"),
      meta: { title: "跟进记录" }
    },
    {
      path: "/addFollow/:id",
      name: "addFollow",
      component: () =>
        import("@/components/StudentFiles/followList/addFollow/index"),
      meta: { title: "添加跟进记录" }
    },
    {
      path: "/employeeList",
      name: "employeeList",
      component: () => import("@/components/StudentFiles/employeeList/index"),
      meta: { title: "员工列表" }
    },
    {
      path: "/enroll",
      name: "enroll",
      component: () => import("@/components/StudentFiles/enroll/index"),
      meta: { title: "报名/缴费", keepAlive: true }
    },
    {
      path: "/paySuccess",
      name: "paySuccess",
      component: () => import("@/components/StudentFiles/paySuccess/index"),
      meta: { title: "报名成功" }
    },
    {
      path: "/receiptWaiting",
      name: "receiptWaiting",
      component: () => import("@/components/StudentFiles/receiptWaiting/index"),
      meta: { title: "订单审批中" }
    },
    {
      path: "/loginOut",
      name: "loginOut",
      component: () => import("@/components/loginOut/loginOut"),
      meta: { title: "提示" }
    },
    {
      path: "/myself",
      name: "myself",
      component: () => import("@/components/myself/myself"),
      meta: { title: "我的", isNotShowBar: true, index: 10 }
    },
    {
      path: "/leaveApplication",
      name: "leaveApplication",
      component: () => import("@/components/leaveApplication/index"),
      meta: { title: "请假申请", keepAlive: true, index: 30 }
    },
    {
      path: "/leaveDetail/:id",
      name: "leaveDetail",
      component: () =>
        import("@/components/leaveApplication/leaveDetail/index"),
      meta: { title: "请假详情" }
    },
    {
      path: "/tryClassApply",
      name: "tryClassApply",
      component: () => import("@/components/tryClassApply/index"),
      meta: { title: "试听申请", keepAlive: true, index: 30 }
    },
    {
      path: "/tryClassDetail/:id",
      name: "tryClassDetail",
      component: () =>
        import("@/components/tryClassApply/tryClassDetail/index"),
      meta: { title: "试听详情" }
    },

    {
      path: "/archives",
      name: "archives",
      component: () => import("@/components/archives/index"),
      meta: { title: "成长档案", keepAlive: true, index: 30 }
    },
    {
      path: "/archivesDetail/:id",
      name: "archivesDetail",
      component: () => import("@/components/archives/archivesDetail/index"),
      meta: { title: "成长档案详情" }
    },
    {
      path: "/addArchives",
      name: "addArchives",
      component: () => import("@/components/archives/addArchives/index"),
      meta: { title: "新增成长档案" }
    },
    {
      path: "/editArchives/:id",
      name: "EditArchives",
      component: () => import("@/components/archives/EditArchives/index"),
      meta: { title: "编辑成长档案" }
    },
    {
      path: "/evaluateClass",
      name: "evaluateClass",
      component: () => import("@/components/evaluateClass/index"),
      meta: { title: "课后评价", keepAlive: true, index: 30 }
    },
    {
      path: "/studentEvaluteDtail/:id",
      name: "studentEvaluteDtail",
      component: () =>
        import(
          "@/components/evaluateClass/studentEvalute/studentEvaluteDtail/index"
        ),
      meta: { title: "评价学员详情" }
    },
    {
      path: "/evaluateDone",
      name: "evaluateDone",
      component: () =>
        import("@/components/evaluateClass/studentEvalute/evaluateDone/index"),
      meta: { title: "评价学员" }
    },
    {
      path: "/evaluateDoneBacth",
      name: "evaluateDoneBacth",
      component: () =>
        import(
          "@/components/evaluateClass/studentEvalute/evaluateDoneBacth/index"
        ),
      meta: { title: "批量评价学员" }
    },
    {
      path: "/evaluateDoneCheck",
      name: "evaluateDoneCheck",
      component: () =>
        import(
          "@/components/evaluateClass/studentEvaluteCheck/evaluateDone/index"
        ),
      meta: { title: "评价学员" }
    },
    {
      path: "/evaluateDoneCheckBatch",
      name: "evaluateDoneCheckBatch",
      component: () =>
        import(
          "@/components/evaluateClass/studentEvaluteCheck/evaluateDoneBatch/index"
        ),
      meta: { title: "批量评价学员" }
    },
    {
      path: "/teacherEvaluteDetail",
      name: "teacherEvaluteDetail",
      component: () =>
        import(
          "@/components/evaluateClass/teacherEvalute/teacherEvaluteDetail/index"
        ),
      meta: { title: "评价老师详情" }
    },
    {
      path: "/schoolTimetable",
      name: "schoolTimetable",
      component: () => import("@/components/schoolTimetable/index"),
      meta: { title: "机构课表", keepAlive: true, index: 30 }
    },
    {
      path: "/schoolTimetableDetail/:id",
      name: "schoolTimetableDetail",
      component: () =>
        import("@/components/schoolTimetable/schoolTimetableDetail/index"),
      meta: { title: "机构课表详情" }
    },
    {
      path: "/editClassTime",
      name: "editClassTime",
      component: () =>
        import("@/components/schoolTimetable/editClassTime/index"),
      meta: { title: "调课" }
    },
    {
      path: "/checkWork/:id",
      name: "checkWork",
      component: () => import("@/components/checkWork"),
      meta: { title: "考勤详情" }
    },
    {
      path: "/teacherSalary",
      name: "teacherSalary",
      component: () => import("@/components/teacherSalary"),
      meta: { title: "个人工资记录" }
    },
    {
      path: "/teacherSalaryDetail/:id",
      name: "teacherSalaryDetail",
      component: () => import("@/components/teacherSalary/teacherSalaryDetail"),
      meta: { title: "个人工资记录详情" }
    },
    {
      path: "/followUpRecord",
      name: "followUpRecord",
      component: () => import("@/components/followUpRecord"),
      meta: { title: "跟进记录", index: 30 }
    },
    {
      path: "/tryClassRecord",
      name: "tryClassRecord",
      component: () => import("@/components/tryClassRecord"),
      meta: { title: "试听记录", index: 30 }
    },
    {
      path: "/AppointmentRecord",
      name: "AppointmentRecord",
      component: () => import("@/components/AppointmentRecord"),
      meta: { title: "约课记录", index: 30 }
    },
    {
      path: "/gift",
      name: "gift",
      component: () => import("@/components/gift"),
      meta: { title: "礼品兑换", index: 30 }
    },
    {
      path: "/giftDetail",
      name: "giftDetail",
      component: () => import("@/components/gift/giftDetail"),
      meta: { title: "礼品兑换" }
    },
    {
      path: "/giveOut",
      name: "giveOut",
      component: () => import("@/components/giveOut"),
      meta: { title: "发放优惠券", index: 30 }
    },
    {
      path: "/warningMgr",
      name: "warningMgr",
      component: () => import("@/components/warningMgr"),
      meta: { title: "预警提醒", index: 30 }
    },
    {
      path: "/orderPayment/:id",
      name: "orderPayment",
      component: () => import("@/components/orderPayment"),
      meta: { title: "订单收款" }
    },
    {
      path: "/orderReturn/:id",
      name: "orderReturn",
      component: () => import("@/components/orderReturn"),
      meta: { title: "销售退单" }
    },
    {
      path: "/PointsRecord",
      name: "PointsRecord",
      component: () => import("@/components/PointsRecord"),
      meta: { title: "积分记录" }
    },
    {
      path: "/goodsPurchase",
      name: "goodsPurchase",
      component: () => import("@/components/goodsPurchase")
    },
    {
      path: "/stockRecord",
      name: "stockRecord",
      component: () => import("@/components/stockRecord")
    },
    {
      path: "/classCancelRecord",
      name: "classCancelRecord",
      component: () => import("@/components/classCancelRecord"),
      meta: { title: "课消记录", index: 30 }
    },
    {
      path: "/inExMgr",
      name: "inExMgr",
      component: () => import("@/components/inExMgr"),
      meta: { title: "收支明细", keepAlive: true, index: 30 }
    },
    {
      path: "/addInExMgr",
      name: "addInExMgr",
      component: () => import("@/components/inExMgr/addInExMgr"),
      meta: { title: "新增收支" }
    },
    {
      path: "/salaryMgr",
      name: "salaryMgr",
      component: () => import("@/components/salaryMgr"),
      meta: { title: "工资结算", keepAlive: true, index: 30 }
    },
    {
      path: "/Addsalary",
      name: "Addsalary",
      component: () => import("@/components/salaryMgr/Addsalary"),
      meta: { title: "新建工资结算" }
    },
    {
      path: "/salarySlip/:id",
      name: "salarySlip",
      component: () => import("@/components/salaryMgr/salarySlip"),
      meta: { title: "工资条" }
    },
    {
      path: "/salaryDetail",
      name: "salaryDetail",
      component: () => import("@/components/salaryMgr/salaryDetail"),
      meta: { title: "工资条详情" }
    },
    {
      path: "/data/students",
      name: "students",
      component: () => import("@/components/data/students"),
      meta: { title: "招生数据", index: 30 }
    },
    {
      path: "/data/sales",
      name: "sales",
      component: () => import("@/components/data/sales"),
      meta: { title: "销售数据", index: 30 }
    },
    {
      path: "/data/academic",
      name: "academic",
      component: () => import("@/components/data/academic"),
      meta: { title: "教务数据", index: 30 }
    },
    {
      path: "/data/financeData",
      name: "financeData",
      component: () => import("@/components/data/financeData"),
      meta: { title: "财务数据", index: 30 }
    },
    {
      path: "/classMgr",
      name: "classMgr",
      component: () => import("@/components/classMgrRe"),
      meta: { title: "班级管理", keepAlive: true, index: 30 }
    },
    {
      path: "/classDetail/:id",
      name: "classDetail",
      component: () => import("@/components/classMgrRe/ClassDetail"),
      meta: { title: "班级详情" }
    },
    {
      path: "/classDetailOver/:id",
      name: "classDetailOver",
      component: () => import("@/components/classMgrRe/ClassDetail"),
      meta: { title: "班级详情", type: "1" }
    },
    {
      path: "/classEdit",
      name: "classEdit",
      component: () => import("@/components/classEdit"),
      meta: { title: "班级编辑" }
    },
    {
      path: "/classAddOneToOne",
      name: "classAddOneToOne",
      component: () => import("@/components/classAddOneToOne"),
      meta: { title: "添加一对一上课" }
    },
    {
      path: "/appCenter",
      name: "appCenter",
      component: () => import("@/components/appCenter"),
      meta: {
        title: "应用中心",
        keepAlive: true,
        index: 20
      }
    },
    {
      path: "/ClassStudent/:id",
      name: "ClassStudent",
      component: () => import("@/components/classMgr/op/ClassStudent"),
      meta: { title: "班级学员" }
    },
    {
      path: "/ClassTimesRule/:id",
      name: "ClassTimesRule",
      component: () => import("@/components/classMgr/op/ClassTimesRule"),
      meta: { title: "班级排课" }
    },
    {
      path: "/ClassTimeRule/:id",
      name: "ClassTimeRule",
      component: () => import("@/components/classMgrRe/ClassTimeRule"),
      meta: { title: "快速排课" }
    },
    {
      path: "/RuleEdit/:id/:rid",
      name: "RuleEdit",
      component: () =>
        import("@/components/classMgr/op/ClassTimesRule/RuleEdit"),
      meta: { title: "编辑排课" }
    },
    {
      path: "/ClassRecordLog/:id",
      name: "ClassRecordLog",
      component: () => import("@/components/classMgr/op/ClassRecordLog"),
      meta: { title: "上课记录" }
    },
    {
      path: "/notice",
      name: "notice",
      component: () => import("@/components/notice"),
      meta: { title: "通知管理", keepAlive: true, index: 30 }
    },
    {
      path: "/wxnoticeDetail/:id",
      name: "wxnoticeDetail",
      component: () => import("@/components/notice/wxnoticeDetail"),
      meta: { title: "通知已读详情" }
    },
    {
      path: "/noticeEdit/:id",
      name: "noticeEdit",
      component: () => import("@/components/notice/op/addnotice"),
      meta: { title: "编辑通知" }
    },
    {
      path: "/noticeAdd",
      name: "noticeAdd",
      component: () => import("@/components/notice/op/addnotice"),
      meta: { title: "添加通知" }
    },
    {
      path: "/smsSend",
      name: "smsSend",
      component: () => import("@/components/notice/op/addmessage"),
      meta: { title: "添加通知" }
    },
    {
      path: "/download/:url",
      name: "download",
      component: () => import("@/components/common/download"),
      meta: { title: "点击下载文件" }
    },
    {
      path: "/studentCourseFastDeClassTimes",
      name: "studentCourseFastDeClassTimes",
      component: () => import("@/components/studentCourseFastDeClassTimes"),
      meta: { title: "快速扣课时", index: 30 }
    },
    {
      path: "/studentCourseFastDeClassTimesBatch",
      name: "studentCourseFastDeClassTimesBatch",
      component: () =>
        import("@/components/studentCourseFastDeClassTimesBatch"),
      meta: { title: "批量扣课时", index: 30 }
    },
    {
      path: "/studentCourse",
      name: "studentCourse",
      component: () => import("@/components/studentCourse"),
      meta: { title: "学员课程", index: 30 }
    },
    {
      path: "/classRecordStudent",
      name: "classRecordStudent",
      component: () => import("@/components/classRecordStudent"),
      meta: { title: "到课记录", index: 30 }
    },
    {
      path: "/attendanceRecord",
      name: "attendanceRecord",
      component: () => import("@/components/attendanceRecord"),
      meta: { title: "考勤记录", index: 30 }
    },
    {
      path: "/achievementList",
      name: "achievementList",
      component: () => import("@/components/achievementList"),
      meta: { title: "成绩单", index: 30 }
    },
    {
      path: "/achievementList2",
      name: "achievementList2",
      component: () => import("@/components/achievementList2"),
      meta: { title: "成绩单高级版", index: 30 }
    },
    {
      path: "/achievementDetails/:id",
      name: "achievementDetails",
      component: () => import("@/components/achievementDetails"),
      props: route => ({ id: route.params.id, type: "edit" }),
      meta: { title: "成绩单详情" }
    },
    {
      path: "/achievementDetails2/:id",
      name: "achievementDetails2",
      component: () => import("@/components/achievementDetails2"),
      props: route => ({ id: route.params.id, type: "edit" }),
      meta: { title: "成绩单详情" }
    },
    {
      path: "/addAchievementDetails",
      name: "addAchievementDetails",
      component: () => import("@/components/achievementDetails"),
      props: { type: "add" },
      meta: { title: "添加成绩单" }
    },
    {
      path: "/businessSummary",
      name: "businessSummary",
      component: () => import("@/components/businessSummary"),
      meta: { title: "经营汇总", index: 30 }
    },
    {
      path: "/scanStudentCode",
      name: "scanStudentCode",
      component: () => import("@/components/scanStudentCode"),
      meta: { title: "扫码扣课时", index: 30 }
    },
    {
      path: "/checkByCode",
      name: "checkByCode",
      component: () => import("@/components/checkByCode"),
      meta: { title: "扫码考勤", index: 30 }
    },
    {
      path: "/userMessageDetail",
      name: "userMessageDetail",
      component: () => import("@/components/userMessageDetail"),
      meta: { title: "通知详情" }
    },
    {
      path: "/xieyi",
      name: "xieyi",
      component: () => import("@/components/protocol/xieyi"),
      meta: { title: window.loadIMG["institution"] + "用户协议" }
    },
    {
      path: "/yins",
      name: "yins",
      component: () => import("@/components/protocol/yins"),
      meta: { title: window.loadIMG["institution"] + "隐私政策" }
    },
    {
      path: "/gonggao",
      name: "gonggao",
      component: () => import("@/components/protocol/gonggao"),
      meta: { title: "公告详情" }
    },
    {
      path: "/feedback",
      name: "feedback",
      component: () => import("@/components/etmsAndroid/feedback"),
      meta: { title: "意见反馈" }
    },
    {
      path: "/aboutme",
      name: "aboutme",
      component: () => import("@/components/etmsAndroid/aboutme"),
      meta: { title: "关于我们" }
    },
    {
      path: "/loginoff",
      name: "loginoff",
      component: () => import("@/components/etmsAndroid/loginoff"),
      meta: { title: "注销账号" }
    },
    {
      path: "/testPage",
      name: "testPage",
      component: () => import("@/components/testPage"),
      meta: { title: "测试" }
    },
    {
      path: "/textBookMy",
      name: "textBookMy",
      component: () => import("@/components/textBookMy"),
      meta: { title: "我的教材" }
    },
    {
      path: "/textBookList",
      name: "textBookList",
      component: () => import("@/components/textBookMy2/textBookMyList"),
      meta: { title: "我的教材" }
    },
    {
      path: "/textbookDetail",
      name: "textbookDetail",
      component: () => import("@/components/textBookMy2/textBookMyDetail"),
      meta: { title: "我的教材" }
    },
    {
      path: "/wxMsg",
      name: "wxMsg",
      component: () => import("@/components/wxMsg"),
      meta: { title: "微信消息" }
    },
    {
      path: "/loginPhoneIos",
      name: "loginPhoneIos",
      component: () => import("@/components/etmsIos/login"),
      meta: { title: "老师登录", isNotShowBar: true }
    },
    {
      path: "/registerPhoneIos",
      name: "registerPhoneIos",
      component: () => import("@/components/etmsIos/register"),
      meta: { title: "注册账号" }
    },
    {
      path: "/feedbackIos",
      name: "feedbackIos",
      component: () => import("@/components/etmsIos/feedback"),
      meta: { title: "意见反馈" }
    },
    {
      path: "/aboutmeIos",
      name: "aboutmeIos",
      component: () => import("@/components/etmsIos/aboutme"),
      meta: { title: "关于我们" }
    },
    {
      path: "/loginoffIos",
      name: "loginoffIos",
      component: () => import("@/components/etmsIos/loginoff"),
      meta: { title: "注销账号" }
    },
    {
      path: "/xieyiIos",
      name: "xieyiIos",
      component: () => import("@/components/protocolIos/xieyi"),
      meta: { title: "小禾帮用户协议" }
    },
    {
      path: "/yinsIos",
      name: "yinsIos",
      component: () => import("@/components/protocolIos/yins"),
      meta: { title: "小禾帮隐私政策" }
    },
    {
      path: "/CourseMgr",
      name: "CourseMgr",
      component: () => import("@/components/CourseMgr"),
      meta: { title: "课程管理", keepAlive: true, index: 30 }
    },
    {
      path: "/AddCourse",
      name: "AddCourse",
      component: () => import("@/components/CourseMgr/AddCourse"),
      props: route => ({ type: route.query.type, cId: route.query.cId }),
      meta: { title: "课程" }
    },
    {
      path: "/AddSetMeal",
      name: "AddSetMeal",
      component: () => import("@/components/CourseMgr/AddSetMeal"),
      props: route => ({ type: route.query.type, id: route.query.id }),
      meta: { title: "套餐" }
    },
    {
      path: "/myQrcode",
      name: "myQrcode",
      component: () => import("@/components/myQrcode"),
      meta: { title: "员工码" }
    },
    {
      path: "/tuijian",
      name: "tuijian",
      component: () => import("@/components/tuijian"),
      meta: { title: "推荐有奖" }
    },
    {
      path: "/classTimesRuleStudent/:cId/:rId",
      name: "classTimesRuleStudent",
      component: () => import("@/components/classMgr/op/classTimesRuleStudent"),
      meta: { title: "班级排课-设置上课学员" }
    },
    {
      path: "/transferOfCourses",
      name: "transferOfCourses",
      component: () => import("@/components/transferOfCourses"),
      meta: { title: "转课" }
    },
    {
      path: "/payVue",
      name: "payVue",
      component: () =>
        import("@/components/StudentFiles/studentDetails/cpn/Acpn/PayVue.vue"),
      meta: { title: "试听付费" }
    },
    {
      path: "/payChooseAccount",
      name: "payChooseAccount",
      component: () => import("@/components/PayChooseAccount"),
      meta: { title: "账户充值" }
    },
    {
      path: "/refundChooseAccount",
      name: "refundChooseAccount",
      component: () => import("@/components/RefundChooseAccount"),
      meta: { title: "账户退款" }
    },
    {
      path: "/rechargeRule",
      name: "rechargeRule",
      component: () => import("@/components/RechargeRule"),
      meta: { title: "充值规则设设置" }
    },
    {
      path: "/tabelClassDetail",
      name: "tabelClassDetail",
      component: () =>
        import("@/components/schoolTimetable/components/ClassDetail"),
      meta: { title: "课次详情" }
    },
    {
      path: "/teacherPayDetail/:cid/:uid",
      name: "teacherPayDetail",
      component: () => import("@/components/teacherSalary/detail/index.vue"),
      meta: { title: "工资详情" }
    },
    {
      path: "/tabelClassDetail1",
      name: "tabelClassDetail1",
      components: () =>
        import("@/components/schoolTimetable/components/ClassDetail1"),
      meta: { title: "课次详情" }
    },
    {
      path: "/SelectionItemsPage",
      name: "SelectionItemsPage",
      component: () => import("@/components/SelectionItemsPage"),
      meta: { title: "选择项目" }
    },
    {
      path: "/studentClassPlacement",
      name: "studentClassPlacement",
      component: () => import("@/components/studentClassPlacement"),
      meta: { title: "选班调班" }
    },
    {
      path: "/ItemsAndExpenseslogs/:id",
      name: "ItemsAndExpenseslogs",
      component: () => import("@/components/ItemsAndExpenseslogs"),
      meta: { title: "库存变动记录" }
    },
    {
      path: "/ItemsAndExpenses",
      name: "ItemsAndExpenses",
      component: () => import("@/components/ItemsAndExpenses"),
      meta: { title: "物品/费用" }
    },
    {
      path: "/StaffManagement",
      name: "StaffManagement",
      component: () => import("@/components/StaffManagement"),
      meta: { title: "员工管理" }
    },
    {
      path: "/chooseC",
      name: "ChooseC",
      component: () => import("@/components/schoolTimetable/ClassPop"),
      meta: { title: "调课选课" }
    },
    {
      path: "/studentGetBuyCode",
      name: "studentGetBuyCode",
      component: () => import("@/components/StudentFiles/studentGetBuyCode"),
      meta: { title: "扫码搜索学员" }
    },
    {
      path: "/giftCenter",
      name: "giftCenter",
      component: () => import("@/components/GiftCenter/index"),
      meta: { title: "礼品中心" }
    },
    {
      path: "/xhform",
      name: "xhform",
      component: () => import("@/components/Xhform/index"),
      meta: { title: "小禾表单" }
    },
    {
      path: "/FormCreat",
      name: "FormCreat",
      component: () => import("@/views/Form/creat.vue"),
      meta: { title: "小禾表单" }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js